import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles((theme) => ({
  container: {
    padding: 0,
    margin: 0,
    height: 478,
    width: 335,
    overflowY: 'clip',
    overflowX: 'hidden',
    borderRadius: theme.spacing(0, 0, 0.5, 0.5),
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 196px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  chipBackground: {
    color: theme.palette.base.white,
    padding: 20,
    backgroundColor: theme.palette.base.green,
    minWidth: 200,
    marginTop: 5,
    '&:hover': {
      backgroundColor: `${theme.palette.base.green} !important`,
      filter: 'brightness(90%)',
    },
    '&:focus': {
      backgroundColor: theme.palette.base.green,
    },
  },
  retainer: {
    width: '100%',
  },
  visibilityIcon: {
    paddingTop: 0,
    fontSize: 42,
    color: theme.palette.base.white,
  },
  transparent: {
    backgroundColor: 'transparent !important',
  },
  modalTab: {
    width: '335px',
    height: '35px',
    minHeight: '35px',
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  linkIcon: {
    color:
      theme.palette.type === 'light'
        ? theme.palette.base.gray
        : theme.palette.base.white,
    fontSize: '30px',
    margin: '0px',
    padding: '0px',
  },
  icon: {
    color:
      theme.palette.type === 'light'
        ? theme.palette.base.gray
        : theme.palette.base.white,
    textAlign: 'center',
    fontSize: '30px',
    '&:hover': {
      transform: 'scale(1.07)',
    },
  },
  panel: {
    height: 443,
    overflowX: 'clip',
    overflowY: 'clip',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 231px)',
      maxHeight: 443,
    },
  },
  fullHeightGrid: {
    height: '100%',
  },
  buttonGrid: {
    height: 361,
    maxHeight: 361,
    overflowY: 'auto',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 313px)',
    },
  },
  buttonGridItem: {
    marginBottom: theme.spacing(1),
    '&:hover': {
      cursor: 'pointer',
    },
  },
  reqHolder: {
    flex: 1,
    padding: theme.spacing(1, 0),
    width: '100%',
    overflowY: 'auto',
    zIndex: 1,
  },
  reqHolderItem: {
    width: '100%',
    [theme.breakpoints.down(400)]: {
      width: 'calc(100% - 8px)',
    },
  },
  noReqBox: {
    background: '#fafafa',
    border: `1px solid ${
      theme.palette.type === 'light'
        ? theme.palette.base.lightGray
        : theme.palette.base.red
    }`,
    padding: '10px',
    margin: '10px',
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: '10px',
  },
  schoolCodeCard: {
    backgroundColor: theme.palette.backgroundColor.ternary,
    color: theme.palette.primary.headerText,
    padding: theme.spacing(0.5, 1),
    width: 'calc(100% - 8px)',
    textAlign: 'center',
    margin: theme.spacing(0.5),
  },
  viewGrid: {
    height: 443,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 231px)',
      maxHeight: 443,
      overflowY: 'auto',
      overflowX: 'hidden',
    },
  },
  viewAwardsGrid: {
    width: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    height: 361,
    maxHeight: 361,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 313px)',
    },
  },
  fullWidth: {
    width: '100%',
  },
  statusButtonGreen: {
    width: '80px',
    backgroundColor: theme.palette.base.green,
    color: theme.palette.base.white,
  },
  statusButtonRed: {
    width: '80px',
    backgroundColor: theme.palette.base.red,
    color: theme.palette.base.white,
  },
  notifyTypeBreak: {
    wordWrap: 'break-word',
  },
  awardCard: {
    margin: '5px',
    padding: '5px',
    backgroundColor: theme.palette.backgroundColor.ternary,
  },
  awardFooter: {
    padding: '0 10px',
  },
  assistanceCard: {
    backgroundColor: theme.palette.backgroundColor.ternary,
    color: theme.palette.primary.headerText,
    padding: theme.spacing(0.5, 1),
    width: 'calc(100% - 8px)',
    textAlign: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(0.5),
  },
  assistanceFooter: {
    alignContent: 'center',
    borderTop: '1px solid',
    borderColor: theme.palette.backgroundColor.ternary,
    backgroundColor: theme.palette.backgroundColor.secondary,
    height: 45,
    borderRadius: theme.spacing(0.5),
  },
  titleRow: {
    backgroundColor: theme.palette.backgroundColor.secondary,
  },
  indexAdjust: {
    width: '100%',
    zIndex: 100,
  },
  linkContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tinyText: {
    fontSize: '10px',
  },
  footer: {
    padding: '0px 5px',
    borderTop: '1px solid',
    borderColor: theme.palette.backgroundColor.ternary,
    backgroundColor: theme.palette.backgroundColor.secondary,
    height: 45,
    paddingTop: '8px',
    borderRadius: theme.spacing(0.5),
  },
  sirsRejectedPromptContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '5px',
    padding: '5px',
    backgroundColor: theme.color.rutgersRed,
    color: theme.color.white,
    borderRadius: '1rem',
  },
}))

export default styles
